module.exports = __webpack_public_path__ + "static/media/03C.c815dbc4.png";